import React from 'react'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import styles from './errorMessageComponent.scss'
import PropTypes from 'prop-types'
export function ErrorMessage (props: Props) {
  const { t } = props
  if (props.errors.length > 0) {
    return (
      <ul className={styles.errorList}>
        {props.errors.map((error, index) => {
          let errorKey
          if (
            error ===
            'login.authenticateUser failed with HTTP status: 401, and the following message: Email/password combination not recognized.'
          ) {
            errorKey = 'notRecognized'
          } else if (
            error ===
            'login.authenticateUser failed with HTTP status: 401, and the following message: Account not activated.'
          ) {
            errorKey = 'notActivated'
          } else {
            errorKey = error
          }
          return <li key={index}>{t(`errors:${errorKey}`)}</li>
        })}
      </ul>
    )
  } else {
    return false
  }
}
ErrorMessage.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
  t: PropTypes.func.isRequired
}

export default compose(pure, translate())(ErrorMessage)



// WEBPACK FOOTER //
// ./src/forms/components/errorMessage/errorMessageComponent.js